import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import TabsLayout from "@layouts/tabs";
import { PATHS } from "@constants/Paths";
import messages from "./messages.i18n";
import { RefetchProvider } from "@piiqtechnologies/ui-lib";
import { PeekGrid, PeekStack, theme, PeekPaper, PeekTypography } from "@piiqtechnologies/ui-components";
import AppHeader from "@components/app-header";
import { Settings } from "@piiqtechnologies/svg-icons";
const USER_SETTINGS_TABS = [
    {
        value: PATHS.USER_SETTINGS_PROFILE,
        label: messages.userSettingsProfileTitle,
    },
    {
        value: PATHS.USER_SETTINGS_EMAIL_NOTIFICATIONS,
        label: messages.userSettingsEmailNotificationsTitle,
    },
];
export const UserSettingsLayout = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const location = useLocation();
    const [tabValue, setTabValue] = useState(null);
    useEffect(() => {
        const usersURLSegments = location.pathname.split("/");
        const activeTabURL = usersURLSegments.pop() || usersURLSegments.pop();
        const isValidTabValue = USER_SETTINGS_TABS.map(({ value }) => value).includes(activeTabURL);
        setTabValue((isValidTabValue && activeTabURL) || PATHS.USERS);
    }, [location.pathname]);
    const handleTabChange = (value) => {
        navigate(value);
    };
    if (!tabValue) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center", height: theme.spacing(4) },
                React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.userSettingsTitle), icon: React.createElement(PeekTypography, { variant: "h2", display: "flex" },
                        React.createElement(Settings, null)) }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(PeekPaper, { sx: { p: 3 } },
                React.createElement(RefetchProvider, null,
                    React.createElement(TabsLayout, { TabAction: null, activeTab: tabValue, tabs: USER_SETTINGS_TABS, TabContent: React.createElement(Outlet, null), onTabChange: handleTabChange }))))));
};
export default UserSettingsLayout;
